/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const BarsSortSolidV6 = (props) => (
  <Icon {...props} name="Bars Sort Solid V6">
    <path d="M1 3a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm0 5a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1zm5 6H2a1 1 0 1 1 0-2h4a1 1 0 1 1 0 2z" />
  </Icon>
);

export default BarsSortSolidV6;
